import CSSModule from './NewBadgeLabel.module.scss';

export const NewBadgeLabel: React.FC = () => (
  <div className={CSSModule.NewBadgeLabel}>
    <div className={CSSModule.NewBadgeLabel__Text}>NEW</div>
  </div>
);
